// @mui
import {
  Card,
  Typography,
} from "@mui/material";
import Iconify from "../../components/Iconify";
import useResponsive from "../../hooks/useResponsive";

// --------------------------------------------------
export default function AddNewJobPostCard({ add }) {
  const smUp = useResponsive('up', 'sm');
  return (
    <Card
      onClick={() => add()}
      sx={{
        minHeight: smUp ? 200 : 150,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: "rgba(0, 0, 0, 0.03)",
        borderRadius: 1.5,
        border: 1,
        borderColor: "rgba(145, 158, 171, 0.24)",
        boxShadow: "none",
        '&:hover': {
          cursor: 'pointer',
          bgcolor: "rgba(145, 158, 171, 0.24)",
        },
      }}
    >
      <Iconify icon="mdi:plus-box" color="text.primary" sx={{ width: "20px", height: "20px", mb: 0.5 }} />
      <Typography variant="overline" component="p">
        새로운 공고 작성하기
      </Typography>
    </Card>
  )
};
